/**
 * Console-log noise that no observability sink should ingest.
 */
const IGNORED_CONSOLE_LOG_PATTERNS = [/###[\s\S]*modal\.jobs/];

export function isIgnoredConsoleLog(message: string): boolean {
  return IGNORED_CONSOLE_LOG_PATTERNS.some((pattern) => pattern.test(message));
}
